import { Opinion, Feedback } from 'services';
import { OpinionCategoryLabels } from '../../services/feedback.model';

export function getUniqueLabels(opinionCategoryLabels: OpinionCategoryLabels): string[] {
  return Array.from(
    Object.keys(opinionCategoryLabels).reduce((prev, cur) => {
      opinionCategoryLabels[cur].forEach(trait => prev.add(trait));
      return prev;
    }, new Set<string>())
  );
}

// Creates the Payload to send to GMC for Release Case
// Feedback and Actions are recorded in this request body as well
export function getOpinionCategoryLabelKeys(opinion: Opinion): string[] {
  return Object.keys(opinion.opinionCategoryLabels);
}

// Return total number of labels in opinion category labels
export function getOpinionCategoryLabelsTotal(opinion: Opinion): number {
  let curLabelTotal = 0;
  getOpinionCategoryLabelKeys(opinion).forEach(category => {
    opinion.opinionCategoryLabels[category].forEach(() => {
      ++curLabelTotal;
    });
  });

  return curLabelTotal;
}

// Checks if opinions are valid -> contains a label and a comment if required.
export function opinionCheck(opinions: Opinion[], moderatorFeedbackCommentOptional: boolean): boolean {
  let flag = true;
  opinions.forEach(opinion => {
    if (!moderatorFeedbackCommentOptional && (opinion.comment === undefined || opinion.comment === '')) {
      flag = false;
    }
    if (getOpinionCategoryLabelKeys(opinion).length === 0) {
      flag = false;
    }
  });
  return flag;
}

export function getTraitCount(opinion: Opinion): number {
  return Object.keys(opinion.opinionCategoryLabels)
    .map<number>((key: string) => opinion.opinionCategoryLabels[key].length)
    .reduce((prev, cur) => prev + cur, 0);
}

export function getFeedbackTraitCount(feedbacks: Feedback[]): { [id: string]: number } {
  return feedbacks.reduce((prev, cur) => {
    let feedbackLabels: string[] = [];

    getOpinionCategoryLabelKeys(cur.opinion).forEach(key => {
      feedbackLabels = feedbackLabels.concat(cur.opinion.opinionCategoryLabels[key]);
    });

    if (feedbackLabels == null) {
      return prev;
    }

    feedbackLabels.forEach(label => {
      if (prev[label] === undefined) {
        prev[label] = 1;
      } else {
        prev[label]++;
      }
    });

    return prev;
  }, {});
}
